
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
  <path
    fill="currentColor"
    d="M234.097778 426.666667h-113.777778V142.222222h284.444444v113.777778h56.888889V85.333333h-398.222222v398.222223h170.666667v-56.888889zM290.986667 312.888889h398.222222v398.222222h-398.222222zM746.097778 540.444444v56.888889h113.777778v284.444445h-284.444445v-113.777778h-56.888889v170.666667h398.222222V540.444444h-170.666666z"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'BringFront',
    }) as DefineComponent
    </script>
    